import { render, staticRenderFns } from "./ViewAdditive.vue?vue&type=template&id=0c5de922&scoped=true&"
import script from "./ViewAdditive.vue?vue&type=script&lang=ts&"
export * from "./ViewAdditive.vue?vue&type=script&lang=ts&"
import style0 from "./ViewAdditive.vue?vue&type=style&index=0&id=0c5de922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5de922",
  null
  
)

export default component.exports